import React from 'react';
import Button from '../../../../components/Button/Button';
import { PortalWithState } from 'react-portal';
import SetWaterSiteModal from './SetWaterSiteModal';
import { IdArrayInput } from '../../../../hooks/useTablePages';
import RequirePerms from '@/components/RequirePerms';

type WaterServicesActionsProps = { ids: IdArrayInput };

const WaterServicesActions: React.FC<WaterServicesActionsProps> = ({
  ids,
}): JSX.Element => {
  return (
    <>
      <RequirePerms waterServices="UPDATE">
        <PortalWithState closeOnOutsideClick closeOnEsc>
          {({ openPortal, closePortal, portal }) => (
            <>
              <Button
                variant="outline"
                disabled={!ids.length}
                icon="edit"
                onClick={openPortal}
              >
                Set Hazard Site
              </Button>
              {portal(
                <SetWaterSiteModal
                  siteType="HAZARD"
                  serviceIds={ids}
                  onClose={closePortal}
                />
              )}
            </>
          )}
        </PortalWithState>
      </RequirePerms>
    </>
  );
};

export default WaterServicesActions;
